import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess3057DruckStatus: 'idle',
    startProcess3057DruckError: undefined as any,
    loadUserParamsProcess3057DruckStatus: 'idle',
    loadUserParamsProcess3057DruckError: undefined as any,

    process3057DruckList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess3057Druck = createAsyncThunk('process3057DruckSlice/startProcess3057Druck', async ({ process3057Druck }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess3057Druck/`,
        prepareData(process3057Druck),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess3057DruckStatus } = getState().process3057DruckSlice
        return startProcess3057DruckStatus !== 'pending'
    }
})

export const loadUserParamsProcess3057Druck = createAsyncThunk('process3057DruckSlice/loadUserParamsProcess3057Druck', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess3057Druck/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess3057DruckStatus } = getState().process3057DruckSlice
        return loadUserParamsProcess3057DruckStatus !== 'pending'
    }
})

const Process3057DruckSlice = createSlice({
    name: 'process3057DruckSlice',
    initialState,
    reducers: {
        resetstartProcess3057Druck: (state) => {
            state.job = undefined
            state.startProcess3057DruckError = undefined
        },
        resetstartProcess3057DruckError: (state) => {
            state.startProcess3057DruckError = undefined
        },
        resetloadUserParamsProcess3057Druck: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess3057DruckError = undefined
        },
        resetloadUserParamsProcess3057DruckError: (state) => {
            state.loadUserParamsProcess3057DruckError = undefined
        },
        removeFromProcess3057DruckListById: (state, action) => {
            state.process3057DruckList = state.process3057DruckList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess3057DruckListByIds: (state, action) => {
            state.process3057DruckList = state.process3057DruckList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process3057DruckList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess3057DruckStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process3057DruckList = []
            state.startProcess3057DruckStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess3057Druck.pending, (state) => {
            state.startProcess3057DruckStatus = 'pending'
            state.startProcess3057DruckError = undefined
        })
        builder.addCase(startProcess3057Druck.fulfilled, (state, action) => {
            state.startProcess3057DruckStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess3057Druck.rejected, (state, action) => {
            state.startProcess3057DruckStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess3057DruckError = action.error.message
            } else {
                state.startProcess3057DruckError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess3057Druck.pending, (state) => {
            state.loadUserParamsProcess3057DruckStatus = 'pending'
            state.loadUserParamsProcess3057DruckError = undefined
        })
        builder.addCase(loadUserParamsProcess3057Druck.fulfilled, (state, action) => {
            state.loadUserParamsProcess3057DruckStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess3057Druck.rejected, (state, action) => {
            state.loadUserParamsProcess3057DruckStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess3057DruckError = action.error.message
            } else {
                state.loadUserParamsProcess3057DruckError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess3057Druck,
    resetstartProcess3057DruckError,
    resetloadUserParamsProcess3057Druck,
    resetloadUserParamsProcess3057DruckError,
    removeFromProcess3057DruckListById,
    removeFromProcess3057DruckListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process3057DruckSlice.actions
export default Process3057DruckSlice.reducer
